/* global angular, _ */
angular.module('ua5App')
    .directive('resourcesNav', ['$state', '$timeout', '$sce', '$rootScope', 'ResourceSections', function($state, $timeout, $sce, $rootScope, ResourceSections) {
        return {
            restrict: 'A',
            templateUrl: 'components/resources-nav/resources-nav.html',
            scope: {
                position: '@'
            },
            link: function($scope, element, attrs) {

                $scope.currentSlug = $state.params.slug;

                $scope.nav = [];
                $scope.childnav = [];

                ResourceSections.data().get(function(data) {

                    var d = data.sections;

                    //process parent sections
                    for (var i = 0; i < d.length; i++) {
                        if (!d[i].parentId) {
                            $scope.nav.push(d[i]);
                        }
                    }
                    // sort them based on rank
                    $scope.nav = _.sortBy($scope.nav, 'rank');

                    //process children sections
                    for (i = 0; i < d.length; i++) {
                        if (d[i].parentId) {
                            $scope.childnav[d[i].parentId] = $scope.childnav[d[i].parentId] ? $scope.childnav[d[i].parentId] : [];
                            $scope.childnav[d[i].parentId].push(d[i]);
                        }
                    }

                    // sort them based on rank
                    for (i = 0; i < $scope.childnav.length; i++) {
                        if ($scope.childnav[i] && $scope.childnav[i].length > 0) {
                            $scope.childnav[i] = _.sortBy($scope.childnav[i], 'rank');
                        }
                    }
                });

            }
        };
    }])
;
